import { httpClientBankingV2 } from './http-client-banking-v2'
import { httpClientBankingV3 } from './http-client-banking-v3'
import { httpClientBffHomeV2, httpClientBffHomeV3 } from './http-client-bff-home'

interface ResolveHomeHttpClient {
  isOneStone: boolean
  isKaravelaEnabled?: boolean
}

export function resolveHomeHttpClient({ isOneStone, isKaravelaEnabled }: ResolveHomeHttpClient) {
  if (isKaravelaEnabled) {
    return isOneStone ? httpClientBffHomeV3 : httpClientBffHomeV2
  }

  return isOneStone ? httpClientBankingV3 : httpClientBankingV2
}
